<v-expansion-panels v-if="!isLoading && codeLevels" variant="accordion">
    <v-expansion-panel
        v-for="(solution, index) in solutions"
        :key="solution.caseCodeLevelSetId">
        <v-expansion-panel-title>
            <span :class="isPrimary(solution) ? 'blue--text' : null">
                {{ getSolutionName(solution) }}
            </span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
            <CaseSolutionFields
                :solution="solution"
                class="my-4"
                @update:solution="(s) => updateSolution(index, s)" />
        </v-expansion-panel-text>
    </v-expansion-panel>
</v-expansion-panels>
<v-skeleton-loader
    v-else
    :loading="isLoading"
    type="table-row, table-row, table-row"></v-skeleton-loader>